import { Table, Button, Space } from '@/shared/ui/primitives';
import { EditOutlined, DeleteOutlined } from '@/shared/ui/icons';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '@/shared/utils/formatters';
import type { ColumnsType } from '@/shared/ui/subpath-types';

interface Props {
  data: any[];
  loading: boolean;
  sortField: string;
  sortDir: string;
  onSort: (field: string) => void;
  onEdit: (id: number) => void;
  onDelete: (item: any) => void;
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

export default function CountryTable({ data, loading, sortField, sortDir, onSort, onEdit, onDelete, page, pageSize, total, onPageChange }: Props) {
  const { t } = useTranslation();

  const columns: ColumnsType<any> = [
    { title: t('common.id'), dataIndex: 'id', sorter: true, sortOrder: sortField === 'id' ? (sortDir === 'asc' ? 'ascend' : 'descend') : null },
    { title: t('countries.nameEn'), dataIndex: 'nameEn', sorter: true, sortOrder: sortField === 'nameEn' ? (sortDir === 'asc' ? 'ascend' : 'descend') : null },
    { title: t('countries.nameAr'), dataIndex: 'nameAr', sorter: true, sortOrder: sortField === 'nameAr' ? (sortDir === 'asc' ? 'ascend' : 'descend') : null },
    { title: t('common.createdAt'), dataIndex: 'createdAt', sorter: true, sortOrder: sortField === 'createdAt' ? (sortDir === 'asc' ? 'ascend' : 'descend') : null, render: (v: string) => formatDateTime(v) },
    {
      title: t('common.actions'),
      render: (_: any, record: any) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => onEdit(record.id)} />
          <Button type="link" danger icon={<DeleteOutlined />} onClick={() => onDelete(record)} />
        </Space>
      ),
    },
  ];

  const handleChange = (pagination: any, _filters: any, sorter: any) => {
    if (sorter?.field) onSort(sorter.field as string);
  };

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
      onChange={handleChange}
      pagination={{
        current: page + 1,
        pageSize,
        total,
        showSizeChanger: false,
        showTotal: (t) => `${t} items`,
        onChange: (p) => onPageChange(p - 1),
      }}
    />
  );
}
